spApp.filter('dataMedium', [
  '$filter',
  ($filter) => {
    return function(theDate) {
      return $filter('limitTo')(theDate, 10, 0);
    }
  }
]);
